import { Paper, Box, CircularProgress } from "@mui/material";
import React, { useRef, useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Col, Row, Container } from "react-bootstrap"
import * as alarmeServices from "../services/alarmeService";
import * as qgbtServices from "../services/qgbtService";
import * as releServices from "../services/relesService";
import * as inversorServices from "../services/inversoresService";
import * as energyMeterServices from "../services/energyMeterService";
import { delay } from "../utils/utils";
import * as getFeatures from "../services/featuresService";
import CircleIcon from '@mui/icons-material/Circle';
import DnsRoundedIcon from '@mui/icons-material/DnsRounded';



export default function UnifilarDiagram() {
    const date = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
    };

    const { usinaId } = useParams();
    const iframeRef = useRef(null);
    const [equipamentsStatus, setEquipamentsStatus] = useState([])
    const [html, setHtmlContent] = useState()
    const [loading, setLoading] = useState(false);
    const [alarmes, setAlarmes] = useState([])
    const [qgbtsStatus, setQgbtsStatus] = useState([])
    const [circuitBreackersStatus, setCircuitBreackersStatus] = useState([])
    const [inversorData, setInversorData] = useState([])
    const [measurerData, setMeasurerData] = useState([])
    const dispatch = useDispatch();

    function formatNumber(value, options = {}) {
        if (typeof value !== "number") return value;
        return value.toLocaleString('pt-BR', {
            minimumFractionDigits: options.minimumFractionDigits ?? 2,
            maximumFractionDigits: options.maximumFractionDigits ?? 2,
            ...options
        });
    }
    async function getData() {
        const features = await getFeatures.getFeatures(usinaId);
        const trackerMapFeature = features.find(f => f.feature === "UnifilarDiagram");
        const trackerMapUrl = trackerMapFeature?.attachmentUrl;
        if (trackerMapUrl) {
            const response = await fetch(trackerMapUrl);
            const data = await response.text();
            setHtmlContent(data);
        }
    }

    async function updatePage() {
        const filters = {
            nome: "",
            usina: usinaId,
            tipo_equipamento: "EnergyTransformer",
            status: "ativo",
            data_inicio: null,
            data_fim: null,
        };

        const [alarmes, qgbts, circuitBreackers, inversors, measurers] = await Promise.all([
            alarmeServices.getAllAlarmsWithoutPagination({
                filters: filters,
                currentPage: 0,
                itemsPerPage: 100
            }),
            qgbtServices.getQgbtLastRecord(usinaId),
            releServices.findAllLastRegister(usinaId),
            inversorServices.findAllLastRegister(usinaId),
            energyMeterServices.getEnergyMeterLastRecord(usinaId)
        ])


        setAlarmes(alarmes.alarmes)
        setQgbtsStatus(qgbts)
        setCircuitBreackersStatus(circuitBreackers)
        setInversorData(inversors)
        setMeasurerData(measurers)
    }

    useEffect(() => {
        setLoading(true);

        getData()
        updatePage()

        setLoading(false);

        let counter = 0;
        dispatch({ type: "SET_COUNTER", value: counter });
        const intervalId = setInterval(() => {
            counter++;
            if (counter === 60) {
                updatePage();
                counter = 0;
            }
            dispatch({ type: "SET_COUNTER", value: counter });
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        changeUnifilarDiagramStatus()
    }, [measurerData])


    async function changeUnifilarDiagramStatus() {
        await delay(300);
        checkMeasurer()
        checkCircuitBreackers()
        checkQgbts()
        checkEnergyTransformerAlarms()
        sumInversorData()
    }

    function checkMeasurer() {
        if (measurerData?.potencia <= 0) {
            const right_arrow_value = document.querySelector('[id*="right-arrow-value"]')

            const right_arrow_text = document.querySelector('[id*="right-arrow-text"]')
            if (right_arrow_value) {
                right_arrow_value.style.fill = "white"
                right_arrow_value.textContent = `${measurerData?.consumed_energy} kW/h`
            }
            if (right_arrow_text) {
                right_arrow_text.style.fontSize = "10px"
                right_arrow_text.style.fill = "white"
                right_arrow_text.textContent = `CONSUMIDA`
            }

            disableArrow("left")
        } else {
            const element = document.querySelector('[id*="left-arrow-value"]')
            if (element) {
                element.style.fill = "white"
                element.textContent = `${formatNumber(measurerData?.injected_energy)} kW/h`
            }

            disableArrow("right")
        }
    }

    function disableArrow(disabled_arrow) {
        const arrow = document.querySelector(`[id*="${disabled_arrow}-arrow"]`)
        const arrow_text = document.getElementById(`${disabled_arrow}-arrow-text`)
        const arrow_value = document.getElementById(`${disabled_arrow}-arrow-value`)
        if (arrow && arrow_text && arrow_value) {
            arrow.style.display = 'none'
            arrow_text.style.display = 'none'
            arrow_value.style.display = 'none'
        }
        if (arrow) {
            arrow.style.display = 'none'
        }
    }

    function checkCircuitBreackers() {
        circuitBreackersStatus.forEach((CBStatus, index) => {
            const pot_total = CBStatus?.potencia_ativa_a + CBStatus?.potencia_ativa_b + CBStatus?.potencia_ativa_c + CBStatus?.fator_potencia_a + CBStatus?.fator_potencia_b + CBStatus?.fator_potencia_c
            const current_total = CBStatus?.corrente_a + CBStatus?.corrente_b + CBStatus?.corrente_c
            const circuitBrackerStatus = document.getElementById(`rl${index + 1}-status`)
            if (!circuitBrackerStatus) { return }

            if ((pot_total + current_total) <= 0) {
                const elements = document.querySelectorAll(`[id*="rl${index + 1}"]`)
                elements.forEach((element) => {
                    if (element) {
                        element.style.stroke = "#0cff00";
                        element.style.fill = "rgba(255,0,0,0)";
                    }
                })
                circuitBrackerStatus.style.fill = "#0cff00";
                circuitBrackerStatus.textContent = "ABERTO";
            }
        })
    }

    function checkQgbts() {
        qgbtsStatus.forEach((qgbt, index) => {
            const qgbtStatus = document.querySelectorAll(`[id*="qgbt${index + 1}-status"]`)
            if (!qgbtStatus) { return }

            if (qgbt.status) {
                qgbtStatus.textContent = "FECHADO"
            } else {
                const elements = document.querySelectorAll(`[id*="qgbt${index + 1}"]`)
                elements.forEach((element) => {
                    if (element) {
                        element.style.stroke = "#0cff00";
                        element.style.fill = "rgba(255,0,0,0)";
                    }
                })
                qgbtStatus.forEach((statusElem) => {
                    statusElem.style.fill = "#0cff00";
                    statusElem.textContent = "ABERTO";
                });
            }
        })
    }

    function checkEnergyTransformerAlarms() {
        alarmes.forEach((alarme) => {
            const element = document.querySelector(`[id*="${normalizeString(alarme?.alarmeTipo?.descricao)}"]`)

            if (element) {
                element.style.fill = "red";
            }
        })
    }

    function normalizeString(str) {
        return str
            .toLowerCase() // converte para minúsculas
            .normalize("NFD") // separa acentos das letras
            .replace(/[\u0300-\u036f]/g, "") // remove os acentos
            .replace(/\s+/g, "") // remove espaços
    }

    function sumInversorData() {
        let current = 0
        let pot_ac = 0
        let pot_dc = 0

        inversorData.forEach((inversor) => {
            current += inversor?.corrente_a
            pot_ac += inversor?.potencia_total_ac
            pot_dc += inversor?.potencia_total_dc
        })
        const pot_ac_element = document.querySelector('[id*="pot-ac"]')
        if (pot_ac_element) {
            pot_ac_element.style.stroke = "none";
            pot_ac_element.style.fill = "#02ff00";
            pot_ac_element.textContent = `POTÊNCIA AC: ${formatNumber(pot_ac)} kW`
        }

        const pot_dc_element = document.querySelector('[id*="pot-dc"]')
        if (pot_dc_element) {
            pot_dc_element.style.stroke = "none";
            pot_dc_element.style.fill = "#02ff00";
            pot_dc_element.textContent = `POTÊNCIA DC: ${formatNumber(pot_dc)} kW`
        }

        const invs_current_element = document.querySelector('[id*="invs-current"]')
        if (invs_current_element) {
            invs_current_element.style.stroke = "none";
            invs_current_element.style.fill = "#02ff00";
            invs_current_element.textContent = `${formatNumber(current)} A`
        }
    }

    let UnifilarDiagram = (
        <>
            {loading ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "75vh",
                    }}
                >
                    <CircularProgress />
                </Box>
            ) : (<>
                <Paper
                    style={{ backgroundColor: "#0a5068", fontFamily: 'sans-serif' }} elevation={3}
                >
                    <Container>
                        <Row
                            className="mb-3 justify-content-center align-items-center"
                            style={{ fontFamily: 'Roboto' }}
                        >
                            <Col
                                xs={12} md={6}
                                className="pt-2 pb-sm-2 text-white d-flex flex-column align-items-start justify-content-center"
                            >
                                <div className="d-flex align-items-center">
                                    <DnsRoundedIcon />
                                    <b style={{ fontSize: "20px", marginLeft: 8 }}>
                                        Diagrama Unifilar
                                    </b>
                                </div>
                            </Col>
                            <Col
                                xs={12} md={6}
                                className="pt-2 pb-sm-2 d-flex flex-column align-items-end justify-content-center"

                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                                    <b className="text-white" >
                                        <CircleIcon sx={{ color: "red" }} /> Ativo
                                    </b>
                                    <b className="text-white">
                                        <CircleIcon sx={{ color: "green" }} /> Inativo
                                    </b>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Paper>

                <Paper
                    style={{ minHeight: "90vh", padding: "15px", backgroundColor: "#0a5068" }} elevation={3}
                >
                    <div
                        className="d-flex justify-content-center align-items-center text-center"

                        dangerouslySetInnerHTML={{ __html: html }}

                        style={{ width: "100%", fontFamily: 'Roboto' }}
                    />
                </Paper>
            </>)
            }
        </>
    )

    return UnifilarDiagram

}